var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pages.length>0)?_c('div',{staticClass:"slider_box"},[_c('slider',{ref:"slider",attrs:{"options":_vm.sliderinit}},[_vm._l((_vm.pages),function(item,index){return _c('slideritem',{key:index,style:(item.style)})}),_vm._v(" "),_c('div',{attrs:{"slot":"loading"},slot:"loading"},[_vm._v("loading...")])],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d704ac3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company_profile/company_profile.vue
// module id = null
// module chunks = 